
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34121',
  depVersions: {
  "documents-public-ui": "static-1.34121",
  "client-types": "static-1.454",
  "documents-lib": "static-1.34126",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1990",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4884",
  "highcharts": "static-8.100",
  "hs-promise-utils": "static-1.5456",
  "hs-test-utils": "static-1.7870",
  "hub-http": "static-1.6080",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11306",
  "I18n": "static-7.1592",
  "jasmine-immutable": "static-1.2880",
  "jasmine-runner": "static-1.6333",
  "lodash": "static-1.3",
  "quartz": "static-1.6814",
  "react": "static-7.182",
  "react-dlb": "static-1.74",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16513",
  "reporting-data": "static-1.66783",
  "reporting-testing-lib": "static-1.8716",
  "reporting-visualizations": "static-1.58859",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4631",
  "webpack-env": "static-1.54",
  "atom": "static-1.4933",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2355",
  "classnames": "static-2.10",
  "cssUtils": "static-1.757",
  "customer-data-filters-ui": "static-1.39130",
  "customer-data-objects": "static-1.7515",
  "customer-data-property-utils": "static-1.7943",
  "data-fetching-client": "static-1.9540",
  "enviro": "static-4.416",
  "FireAlarmUi": "static-1.4392",
  "flux-actions": "static-1.320",
  "FormsCommonComponents": "static-1.85445",
  "FormUrlGenerator": "static-2.4584",
  "foundations-components": "static-1.7642",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11614",
  "icons": "static-2.634",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7022",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.377",
  "property-description-translator": "static-1.3718",
  "property-translator": "static-1.5272",
  "quartz-config": "static-1.592",
  "quartz-core": "static-1.6033",
  "quick-fetch": "static-1.3797",
  "raven": "static-3.5768",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5234",
  "react-virtualized": "static-2.95",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8027",
  "reference-resolvers-lite": "static-1.7948",
  "report-customization-components": "static-1.12695",
  "reporting-enablement": "static-1.22306",
  "reporting-reports": "static-1.66461",
  "reporting-snowflake": "static-1.55401",
  "reporting-ui-components": "static-2.64054",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4505",
  "sales-content-partitioning": "static-1.8799",
  "SalesContentIndexUI": "static-3.9000",
  "sanitize": "static-1.4337",
  "sanitize-text": "static-1.8008",
  "self-service-api": "static-1.10105",
  "SharedI18nStrings": "static-1.181",
  "SharedLegalStrings": "static-1.1614",
  "signup-constants": "static-1.18525",
  "signup-ui-lego-core": "static-1.20535",
  "signup-ui-url-generator": "static-2.7898",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4632",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10856",
  "ui-addon-i18n": "static-1.11008",
  "ui-addon-react-router-dom": "static-1.9408",
  "ui-addon-upgrades": "static-9.17750",
  "ui-asset-management-lib": "static-1.10798",
  "ui-images": "static-2.1117",
  "UIComponents": "static-3.8253",
  "usage-tracker": "static-1.7198",
  "usage-tracker-container": "static-1.7188",
  "usage-tracker-core": "static-1.7048",
  "usage-tracker-public": "static-1.7009",
  "viral-links-lib": "static-1.6903",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven-hubspot": "static-1.6075",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3289",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3091",
  "quartz-webpack": "static-1.3038",
  "ai-components-ui-library": "static-1.8539",
  "amplitude-session-replay-browser": "static-1.56",
  "foundations-assets": "static-1.4704",
  "foundations-theming": "static-1.4274",
  "quartz-auth": "static-1.489",
  "ui-business-units-lib": "static-1.8895",
  "usage-tracker-session-replay": "static-1.4884",
  "foundations-theming-base": "static-1.3259",
  "HeadJS": "static-2.727",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2981",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4189",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7787",
  "graphql": "static-1.78",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3479",
  "persist-promise": "static-1.3571",
  "reporting-client-types": "static-1.2407",
  "foundations-components-legacy": "static-1.667",
  "hs-story-utils": "static-1.9289",
  "react-flip-move": "static-1.66",
  "hub-http-shared-msw-handlers": "static-1.9631",
  "hubspotter-http": "static-1.4537",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7112",
  "crm-message-bus": "static-1.42555",
  "customer-data-filters-ui-msw-helpers": "static-1.21565",
  "customer-data-objects-ui-components": "static-1.12875",
  "customer-data-reference-ui-components": "static-1.13011",
  "customer-data-ui-utilities": "static-1.9687",
  "framework-builder-read-service-client": "static-1.3892",
  "framework-data-schema-quick-fetch": "static-1.6641",
  "framework-data-schema-resolvers": "static-1.6736",
  "inbound-db-properties-service-client": "static-1.3730",
  "multi-account-reference-resolvers": "static-1.839",
  "onboarding-tours": "static-1.16350",
  "reporting-datasets-permissions-lib": "static-1.13239",
  "ui-addon-teams": "static-1.21330",
  "apollo-stack-hubspot": "static-3.82",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67814",
  "customer-data-properties": "static-1.50983",
  "forms-ai-lib": "static-1.4096",
  "forms-utils-lib": "static-1.12293",
  "foundations-components-test-utils": "static-1.5125",
  "react-dnd-compat": "static-1.4483",
  "react-tinymce": "static-1.54799",
  "tinymce-config": "static-2.53925",
  "ui-gdpr-components": "static-1.10211",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3911",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1382",
  "ui-fonts": "static-1.568",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.812",
  "mobile-manifest-mixins": "static-1.502",
  "module-federation": "static-1.19",
  "quartz-head": "static-1.479",
  "quartz-i18n": "static-1.489",
  "quartz-routing": "static-1.244",
  "quartz-test": "static-1.489",
  "quartz-tracking": "static-1.193",
  "batch-promise": "static-1.1414",
  "external-options-client-types": "static-1.4043",
  "react-colorpicker": "static-2.10074",
  "copilot-toolkit": "static-1.10699",
  "data-quality-ui-library": "static-1.12479",
  "html-to-image": "static-1.50",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6326",
  "reporting-action-components": "static-1.40822",
  "reporting-insights-lib": "static-1.1254",
  "reporting-plugins": "static-1.10057",
  "ui-addon-draggable-compat": "static-2.4117",
  "ui-addon-opt": "static-4.8246",
  "ui-shepherd-react": "static-3.10009",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24905",
  "hubspot-apollo-client": "static-1.4742",
  "chirp-fetch": "static-1.1746",
  "sales-templates-service-types-lib": "static-1.4051",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5579",
  "salesImages": "static-1.522",
  "ts-schema": "static-1.3964",
  "timezone-utils": "static-2.5107",
  "bender-build-tools": "static-1.3018",
  "chatspot-core": "static-1.20601",
  "bend-plugin-foundations-theming": "static-1.2757",
  "stylex": "static-1.28",
  "hubspotter-http-shared-msw-handlers": "static-1.9629",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3682",
  "crm-pipelines-api-client-types": "static-1.4024",
  "multi-currency-client-types": "static-1.3574",
  "getting-started-shared-tasks": "static-1.18056",
  "growth-data-modal": "static-1.5222",
  "growth-onboarding-confetti": "static-1.2935",
  "growth-onboarding-next-action-utils": "static-1.1462",
  "navigation-components": "static-1.17479",
  "onboarding-tours-client": "static-1.4564",
  "onboarding-tours-utils": "static-1.416",
  "ui-shepherd-tracker": "static-1.7390",
  "ui-universal-auth": "static-1.8785",
  "user-context": "static-1.4963",
  "cms-field-types": "static-1.4672",
  "content-icons-ui": "static-1.2181",
  "integrations-lib": "static-1.15622",
  "calling-global-api": "static-1.63920",
  "calling-internal-common": "static-1.31163",
  "calling-lifecycle-internal": "static-1.65302",
  "calling-lifecycle-messages": "static-1.57596",
  "commerce-products-lib": "static-1.9022",
  "crm-links": "static-1.6132",
  "file-manager-components": "static-1.23106",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.550",
  "inbounddb-objects-service-types": "static-1.4107",
  "meetings-icalendar-utils-lib": "static-1.495",
  "object-builder-ui-client": "static-1.48205",
  "pipeline-validation-client-types": "static-1.3848",
  "property-value-citations": "static-1.1597",
  "pulse": "static-1.387",
  "smart-property-lib": "static-1.6174",
  "tiered-pricing": "static-1.927",
  "ui-addon-iframeable": "static-1.8910",
  "final-form": "static-1.66",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19582",
  "tinymce-themes": "static-1.55895",
  "data-token-picker": "static-1.16154",
  "hub-http-contrib": "static-1.2906",
  "interframe": "static-3.4625",
  "tinymce-data": "static-1.40010",
  "tinymce-plugins": "static-1.57039",
  "ui-addon-sales-email": "static-1.5076",
  "magpie-lib": "static-1.5457",
  "magpie-types": "static-1.4917",
  "simple-logging-lib": "static-1.2913",
  "content-assistance-lib": "static-1.7536",
  "dashboard-lib": "static-1.80885",
  "ExportDialog": "static-6.10251",
  "hubspot-prosemirror": "static-1.17785",
  "hubspot-prosemirror-plugins": "static-1.17777",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8556",
  "campaign-roi-lib": "static-1.8468",
  "feedback-loader": "static-1.28996",
  "apollo-link-hub-http": "static-2.4514",
  "hubspot-apollo-cache": "static-1.201",
  "growth-monetization-service-types": "static-1.4362",
  "nav-client-types": "static-1.2220",
  "purchase-motions-api": "static-1.5582",
  "trials-service-types": "static-1.3763",
  "growth-onboarding-next-action-components": "static-1.1490",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.588",
  "unified-auth-core-lib": "static-1.580",
  "getting-started-shared-tasks-store": "static-1.17174",
  "integrations-error-boundary-lib": "static-1.13037",
  "integrations-tracking-lib": "static-1.5453",
  "native-integrations-shared-strings": "static-1.7650",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10237",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31169",
  "shared-worker-versioning": "static-1.10902",
  "calling-usage-tracker": "static-1.6404",
  "voice-sms-access-library": "static-1.430",
  "customer-data-tracking": "static-1.6745",
  "commerce-permissions": "static-1.626",
  "products-iframe-lib": "static-1.7506",
  "products-ui-components-shared-msw-handlers": "static-1.10013",
  "location-customization-utils-lib": "static-1.8760",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4017",
  "video-components-external": "static-1.10771",
  "video-data-lib": "static-1.34429",
  "directed-graph": "static-1.802",
  "event-emitter": "static-1.810",
  "fast-json-patch": "static-1.59",
  "breeze-intelligence-kit": "static-1.5410",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9714",
  "fsm": "static-1.3593",
  "policy-lib": "static-1.6641",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9777",
  "navigation-messaging": "static-1.6806",
  "FileManagerLib": "static-1.38746",
  "NamespacedHubStyle": "static-2.8954",
  "FileManagerCore": "static-1.38605",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12163",
  "layout-dnd-utils": "static-1.11138",
  "react-codemirror": "static-1.10489",
  "ui-addon-emoji-picker": "static-1.9750",
  "ui-brand-identity-lib": "static-1.14337",
  "ui-addon-video-player": "static-1.8559",
  "ui-coaching-tips": "static-1.28111",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8421",
  "payment-link-components": "static-1.23104",
  "EmailSignatureEditor": "static-1.24023",
  "eligibility-engine-service-types": "static-1.3044",
  "universal-page-editor-lib": "static-1.2864",
  "calling-orchestration-schema": "static-1.35207",
  "sales-views-client-types": "static-1.4135",
  "crm-record-cards-service-types": "static-1.3501",
  "content-media-composition-data-lib": "static-1.11704",
  "content-media-compositions": "static-2.15711",
  "media-bridge-lib": "static-1.18676",
  "trellis-story-utils": "static-1.4383",
  "storybook-react": "static-1.29",
  "audio-components": "static-1.5700",
  "FileManagerImages": "static-1.36257",
  "video-components": "static-1.12774",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4394",
  "video-embed": "static-1.35263",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67889",
  "layout-data-lib": "static-1.9463",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6444",
  "commerce-tours-lib": "static-1.5817",
  "growth-onboarding-reliability": "static-1.4949",
  "sales-checkout-service-client": "static-1.3531",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21420",
  "sales-email-signature-service-client": "static-1.3706",
  "hls.js": "static-1.35",
  "social-insights-client-types": "static-1.21568",
  "outpost": "static-1.4062",
  "advanced-menus-core": "static-1.14906",
  "advanced-menus-lib": "static-1.11874",
  "ui-memberships-settings-lib": "static-1.33617",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14905",
  "simple-menus-lib": "static-1.16422"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34121",
  "client-types": "/client-types/static-1.454",
  "documents-lib": "/documents-lib/static-1.34126",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1990",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4884",
  "highcharts": "/highcharts/static-8.100",
  "hs-promise-utils": "/hs-promise-utils/static-1.5456",
  "hs-test-utils": "/hs-test-utils/static-1.7870",
  "hub-http": "/hub-http/static-1.6080",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11306",
  "I18n": "/I18n/static-7.1592",
  "jasmine-immutable": "/jasmine-immutable/static-1.2880",
  "jasmine-runner": "/jasmine-runner/static-1.6333",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6814",
  "react": "/react/static-7.182",
  "react-dlb": "/react-dlb/static-1.74",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16513",
  "reporting-data": "/reporting-data/static-1.66783",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8716",
  "reporting-visualizations": "/reporting-visualizations/static-1.58859",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4631",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4933",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2355",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.757",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39130",
  "customer-data-objects": "/customer-data-objects/static-1.7515",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7943",
  "data-fetching-client": "/data-fetching-client/static-1.9540",
  "enviro": "/enviro/static-4.416",
  "FireAlarmUi": "/FireAlarmUi/static-1.4392",
  "flux-actions": "/flux-actions/static-1.320",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85445",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4584",
  "foundations-components": "/foundations-components/static-1.7642",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11614",
  "icons": "/icons/static-2.634",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7022",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "property-description-translator": "/property-description-translator/static-1.3718",
  "property-translator": "/property-translator/static-1.5272",
  "quartz-config": "/quartz-config/static-1.592",
  "quartz-core": "/quartz-core/static-1.6033",
  "quick-fetch": "/quick-fetch/static-1.3797",
  "raven": "/raven/static-3.5768",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5234",
  "react-virtualized": "/react-virtualized/static-2.95",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8027",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7948",
  "report-customization-components": "/report-customization-components/static-1.12695",
  "reporting-enablement": "/reporting-enablement/static-1.22306",
  "reporting-reports": "/reporting-reports/static-1.66461",
  "reporting-snowflake": "/reporting-snowflake/static-1.55401",
  "reporting-ui-components": "/reporting-ui-components/static-2.64054",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4505",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8799",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9000",
  "sanitize": "/sanitize/static-1.4337",
  "sanitize-text": "/sanitize-text/static-1.8008",
  "self-service-api": "/self-service-api/static-1.10105",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1614",
  "signup-constants": "/signup-constants/static-1.18525",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20535",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7898",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4632",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10856",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11008",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9408",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17750",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10798",
  "ui-images": "/ui-images/static-2.1117",
  "UIComponents": "/UIComponents/static-3.8253",
  "usage-tracker": "/usage-tracker/static-1.7198",
  "usage-tracker-container": "/usage-tracker-container/static-1.7188",
  "usage-tracker-core": "/usage-tracker-core/static-1.7048",
  "usage-tracker-public": "/usage-tracker-public/static-1.7009",
  "viral-links-lib": "/viral-links-lib/static-1.6903",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3289",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3091",
  "quartz-webpack": "/quartz-webpack/static-1.3038",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8539",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4704",
  "foundations-theming": "/foundations-theming/static-1.4274",
  "quartz-auth": "/quartz-auth/static-1.489",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8895",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4884",
  "foundations-theming-base": "/foundations-theming-base/static-1.3259",
  "HeadJS": "/HeadJS/static-2.727",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2981",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4189",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7787",
  "graphql": "/graphql/static-1.78",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3479",
  "persist-promise": "/persist-promise/static-1.3571",
  "reporting-client-types": "/reporting-client-types/static-1.2407",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.667",
  "hs-story-utils": "/hs-story-utils/static-1.9289",
  "react-flip-move": "/react-flip-move/static-1.66",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9631",
  "hubspotter-http": "/hubspotter-http/static-1.4537",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7112",
  "crm-message-bus": "/crm-message-bus/static-1.42555",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21565",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12875",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13011",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9687",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3892",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6641",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6736",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3730",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.839",
  "onboarding-tours": "/onboarding-tours/static-1.16350",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13239",
  "ui-addon-teams": "/ui-addon-teams/static-1.21330",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67814",
  "customer-data-properties": "/customer-data-properties/static-1.50983",
  "forms-ai-lib": "/forms-ai-lib/static-1.4096",
  "forms-utils-lib": "/forms-utils-lib/static-1.12293",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5125",
  "react-dnd-compat": "/react-dnd-compat/static-1.4483",
  "react-tinymce": "/react-tinymce/static-1.54799",
  "tinymce-config": "/tinymce-config/static-2.53925",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10211",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3911",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1382",
  "ui-fonts": "/ui-fonts/static-1.568",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.812",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.502",
  "module-federation": "/module-federation/static-1.19",
  "quartz-head": "/quartz-head/static-1.479",
  "quartz-i18n": "/quartz-i18n/static-1.489",
  "quartz-routing": "/quartz-routing/static-1.244",
  "quartz-test": "/quartz-test/static-1.489",
  "quartz-tracking": "/quartz-tracking/static-1.193",
  "batch-promise": "/batch-promise/static-1.1414",
  "external-options-client-types": "/external-options-client-types/static-1.4043",
  "react-colorpicker": "/react-colorpicker/static-2.10074",
  "copilot-toolkit": "/copilot-toolkit/static-1.10699",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12479",
  "html-to-image": "/html-to-image/static-1.50",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6326",
  "reporting-action-components": "/reporting-action-components/static-1.40822",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1254",
  "reporting-plugins": "/reporting-plugins/static-1.10057",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4117",
  "ui-addon-opt": "/ui-addon-opt/static-4.8246",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10009",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24905",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4742",
  "chirp-fetch": "/chirp-fetch/static-1.1746",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4051",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5579",
  "salesImages": "/salesImages/static-1.522",
  "ts-schema": "/ts-schema/static-1.3964",
  "timezone-utils": "/timezone-utils/static-2.5107",
  "bender-build-tools": "/bender-build-tools/static-1.3018",
  "chatspot-core": "/chatspot-core/static-1.20601",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2757",
  "stylex": "/stylex/static-1.28",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9629",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3682",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4024",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3574",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18056",
  "growth-data-modal": "/growth-data-modal/static-1.5222",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2935",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1462",
  "navigation-components": "/navigation-components/static-1.17479",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4564",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.416",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7390",
  "ui-universal-auth": "/ui-universal-auth/static-1.8785",
  "user-context": "/user-context/static-1.4963",
  "cms-field-types": "/cms-field-types/static-1.4672",
  "content-icons-ui": "/content-icons-ui/static-1.2181",
  "integrations-lib": "/integrations-lib/static-1.15622",
  "calling-global-api": "/calling-global-api/static-1.63920",
  "calling-internal-common": "/calling-internal-common/static-1.31163",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65302",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57596",
  "commerce-products-lib": "/commerce-products-lib/static-1.9022",
  "crm-links": "/crm-links/static-1.6132",
  "file-manager-components": "/file-manager-components/static-1.23106",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.550",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4107",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.495",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48205",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3848",
  "property-value-citations": "/property-value-citations/static-1.1597",
  "pulse": "/pulse/static-1.387",
  "smart-property-lib": "/smart-property-lib/static-1.6174",
  "tiered-pricing": "/tiered-pricing/static-1.927",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8910",
  "final-form": "/final-form/static-1.66",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19582",
  "tinymce-themes": "/tinymce-themes/static-1.55895",
  "data-token-picker": "/data-token-picker/static-1.16154",
  "hub-http-contrib": "/hub-http-contrib/static-1.2906",
  "interframe": "/interframe/static-3.4625",
  "tinymce-data": "/tinymce-data/static-1.40010",
  "tinymce-plugins": "/tinymce-plugins/static-1.57039",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5076",
  "magpie-lib": "/magpie-lib/static-1.5457",
  "magpie-types": "/magpie-types/static-1.4917",
  "simple-logging-lib": "/simple-logging-lib/static-1.2913",
  "content-assistance-lib": "/content-assistance-lib/static-1.7536",
  "dashboard-lib": "/dashboard-lib/static-1.80885",
  "ExportDialog": "/ExportDialog/static-6.10251",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17785",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17777",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8556",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8468",
  "feedback-loader": "/feedback-loader/static-1.28996",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4514",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.201",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4362",
  "nav-client-types": "/nav-client-types/static-1.2220",
  "purchase-motions-api": "/purchase-motions-api/static-1.5582",
  "trials-service-types": "/trials-service-types/static-1.3763",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1490",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.588",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.580",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17174",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13037",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5453",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7650",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10237",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31169",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10902",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6404",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.430",
  "customer-data-tracking": "/customer-data-tracking/static-1.6745",
  "commerce-permissions": "/commerce-permissions/static-1.626",
  "products-iframe-lib": "/products-iframe-lib/static-1.7506",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10013",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8760",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4017",
  "video-components-external": "/video-components-external/static-1.10771",
  "video-data-lib": "/video-data-lib/static-1.34429",
  "directed-graph": "/directed-graph/static-1.802",
  "event-emitter": "/event-emitter/static-1.810",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5410",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9714",
  "fsm": "/fsm/static-1.3593",
  "policy-lib": "/policy-lib/static-1.6641",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9777",
  "navigation-messaging": "/navigation-messaging/static-1.6806",
  "FileManagerLib": "/FileManagerLib/static-1.38746",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8954",
  "FileManagerCore": "/FileManagerCore/static-1.38605",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12163",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11138",
  "react-codemirror": "/react-codemirror/static-1.10489",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9750",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14337",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8559",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28111",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8421",
  "payment-link-components": "/payment-link-components/static-1.23104",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24023",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3044",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2864",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35207",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3501",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11704",
  "content-media-compositions": "/content-media-compositions/static-2.15711",
  "media-bridge-lib": "/media-bridge-lib/static-1.18676",
  "trellis-story-utils": "/trellis-story-utils/static-1.4383",
  "storybook-react": "/storybook-react/static-1.29",
  "audio-components": "/audio-components/static-1.5700",
  "FileManagerImages": "/FileManagerImages/static-1.36257",
  "video-components": "/video-components/static-1.12774",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4394",
  "video-embed": "/video-embed/static-1.35263",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67889",
  "layout-data-lib": "/layout-data-lib/static-1.9463",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6444",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5817",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4949",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3531",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21420",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3706",
  "hls.js": "/hls.js/static-1.35",
  "social-insights-client-types": "/social-insights-client-types/static-1.21568",
  "outpost": "/outpost/static-1.4062",
  "advanced-menus-core": "/advanced-menus-core/static-1.14906",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11874",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33617",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14905",
  "simple-menus-lib": "/simple-menus-lib/static-1.16422"
}
};
